import {
  MissionHeartEmojiImage,
  MissionBackgroundRotation1Image,
  MissionBackgroundParticle1Image,
} from '@local/assets/images'

import Image from '@web/components/Image'
import ProfileThumbnail from '@web/components/ProfileThumbnail'
import useMe from '@web/hooks/useMe'
import { useRegistToSequentialList } from '@web/libs/sequential'

import styles from '../MissionRewardPopup.module.scss'

interface Props {
  title: string
  borderName: string
  animationOrder: number
}

const ProfileBorderRewardPopup = ({ animationOrder, title, borderName }: Props) => {
  const { me } = useMe()

  useRegistToSequentialList({
    order: animationOrder * 100,
    onExecute: () => {},
    type: 'afterPrev',
    delaySeconds: 0,
    durationSeconds: 1,
    id: `reward-popup-${animationOrder}`,
  })

  return (
    <>
      <div className={styles.animation_wrapper}>
        <Image className={styles.img_bg} src={MissionBackgroundRotation1Image} width={680} height={680} alt="" />
      </div>
      <div className={styles.animation_wrapper}>
        <Image className={styles.img_particle} src={MissionBackgroundParticle1Image} width={375} height={340} alt="" />
      </div>
      <div className={styles.content}>
        <div className={styles.mission}>미션 결과</div>
        <div className={styles.tit_area}>
          {title}!
          <Image src={MissionHeartEmojiImage} className={styles.emoji} width={38} height={38} alt="" />
        </div>
        <div className={styles.profile_area}>
          <ProfileThumbnail
            size={144}
            outPosition={36}
            thumbnailUrl={me?.profile?.originImageUrl}
            border={me?.profile?.border}
            noBorder
          />
        </div>
        <div className={styles.txt_area}>{borderName} 득템!</div>
        <div className={styles.description_area}>
          내 리뷰가 노출되는 영역에서 다른 사람들이
          <br />
          {borderName.replace('프로필', '')}를 두른 내 프로필을 볼 수 있어요.
        </div>
      </div>
    </>
  )
}

export default ProfileBorderRewardPopup
